import { combineReducers } from "redux";
import { createSelector } from "reselect";
import { getType } from "typesafe-actions";
import { RootAction, RootState } from "..";
import * as actions from "../bootstrap/actions";
import { getOverrides } from "../overrides/reducers";
import { IState } from "./types";

export default combineReducers<IState, RootAction>({
  rules: (state = null, action: RootAction) => {
    switch (action.type) {
      case getType(actions.addGameRules):
        return action.payload;
      default:
        return state;
    }
  },
  scoring: (state = null, action: RootAction) => {
    switch (action.type) {
      case getType(actions.addGameScoring):
        return action.payload;
      default:
        return state;
    }
  },
  settings: (state = null, action: RootAction) => {
    switch (action.type) {
      case getType(actions.addGameSettings):
        return action.payload;
      default:
        return state;
    }
  },
  status: (state = null, action: RootAction) => {
    switch (action.type) {
      case getType(actions.addGameStatus):
        return action.payload;
      default:
        return state;
    }
  },
  total_players: (state = 0, action: RootAction) => {
    switch (action.type) {
      case getType(actions.addTotalPlayers):
        return action.payload;
      default:
        return state;
    }
  },
});

// State Selectors
export const getRules = createSelector(
  [
    (state) => state,
    (state, eventId?, chipId?) => getOverrides(state, eventId, chipId),
  ],
  (state, overrides) => {
    if (state.game.rules) {
      if (!overrides) {
        return state.game.rules;
      } else {
        return {
          ...state.game.rules,
          ...overrides.rules,
        };
      }
    } else {
      return null;
    }
  },
);

export const getScoring = createSelector(
  [(state) => state, (state, eventId?) => getOverrides(state, eventId)],
  (state, overrides) => {
    if (state.game.scoring) {
      if (!overrides) {
        return state.game.scoring;
      } else {
        return {
          ...state.game.scoring,
          ...overrides.scoring,
        };
      }
    } else {
      return null;
    }
  },
);

export const getSettings = (state: RootState) => state.game.settings;

export const getStatus = (state: RootState) => state.game.status;

export const getTotalPlayers = (state: RootState) => state.game.total_players;
